import React from 'react';
import { useTheme } from 'styled-components';

const IconQuestionMark: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  const theme = useTheme();
  const color1 = theme.icon.color1;
  return (
    <svg viewBox="0 0 14 16" fill="none" {...props}>
      <path
        d="M6.91723 16V13.4502C3.36875 13.266 0.542725 10.3196 0.542725 6.72864C0.542725 3.01726 3.55999 0 7.27137 0C10.9827 0 14 3.01726 14 6.72864C14 10.2346 11.5635 13.7618 7.93006 15.5113L6.91723 16ZM7.27137 1.41656C4.33909 1.41656 1.95928 3.79637 1.95928 6.72864C1.95928 9.66091 4.33909 12.0407 7.27137 12.0407H8.33378V13.6698C10.9119 12.0407 12.5835 9.36343 12.5835 6.72864C12.5835 3.79637 10.2036 1.41656 7.27137 1.41656ZM6.56309 9.56175H7.97964V10.9783H6.56309V9.56175ZM7.97964 8.49934H6.56309C6.56309 6.19743 8.68792 6.3745 8.68792 4.95795C8.68792 4.17884 8.05047 3.54139 7.27137 3.54139C6.49226 3.54139 5.85481 4.17884 5.85481 4.95795H4.43825C4.43825 3.39265 5.70607 2.12483 7.27137 2.12483C8.83666 2.12483 10.1045 3.39265 10.1045 4.95795C10.1045 6.72864 7.97964 6.90571 7.97964 8.49934Z"
        fill={color1}
      />
    </svg>
  );
};

export default IconQuestionMark;
